import { render, staticRenderFns } from "./ClassicDimensionBoostRow.vue?vue&type=template&id=73dd1eee&scoped=true"
import script from "./ClassicDimensionBoostRow.vue?vue&type=script&lang=js"
export * from "./ClassicDimensionBoostRow.vue?vue&type=script&lang=js"
import style0 from "./ClassicDimensionBoostRow.vue?vue&type=style&index=0&id=73dd1eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd1eee",
  null
  
)

export default component.exports